import React from "react";

export function useIsDraggingOver(element: HTMLElement | null) {
  const [count, setCount] = React.useState(0);

  React.useEffect(() => {
    if (!element) return;
    const handleDragEnter = () => setCount((x) => x + 1);
    const handleDragLeave = () => setCount((x) => x - 1);
    element.addEventListener("dragenter", handleDragEnter);
    element.addEventListener("dragleave", handleDragLeave);

    return () => {
      element.removeEventListener("dragenter", handleDragEnter);
      element.removeEventListener("dragleave", handleDragLeave);
    };
  }, [element]);

  React.useEffect(() => {
    if (!element && count) {
      setCount(0);
    }
  }, [element, count]);

  return count > 0;
}
